import { render, staticRenderFns } from "./PacienteFichaCobrancasTabela.vue?vue&type=template&id=44921a9c&scoped=true"
import script from "./PacienteFichaCobrancasTabela.vue?vue&type=script&lang=js"
export * from "./PacienteFichaCobrancasTabela.vue?vue&type=script&lang=js"
import style0 from "./PacienteFichaCobrancasTabela.vue?vue&type=style&index=0&id=44921a9c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44921a9c",
  null
  
)

export default component.exports